import { useMemo } from 'react';

export default function useAchatsMetrics(achats, produits, statuts) {
  // Fonction pour obtenir le libellé d'un statut
  const getStatutLabel = (id) => {
    if (!statuts) return id;
    const statutsArray = Array.isArray(statuts) ? statuts : statuts.data ? statuts.data : statuts.data?.data ? statuts.data.data : [];
    if (!Array.isArray(statutsArray)) return id;
    if (typeof id === 'object' && id !== null) return id.Titre || id.nom || id;
    if (typeof id === 'string') {
      const statut = statutsArray.find(s => (typeof s === 'object' && s !== null) && (s.id === id || s._id === id));
      if (statut) return statut.Titre || statut.nom || statut;
    }
    return id;
  };

  return useMemo(() => {
    // Calcul des achats en cours
    const achatsEnCours = achats.filter(achat => {
      const statutLabel = getStatutLabel(achat.Statut);
      return !["Expédié", "Reçu", "Remboursé", "Expédié - FBM"].includes(statutLabel);
    });

    // Calcul du stock Amazon
    const achatsStockAmazonMap = new Map();
    achats.forEach(achat => {
      const statutLabel = getStatutLabel(achat.Statut);
      const stockRestant = Number(achat.stockRestant) || 0;
      const isIncluded = (statutLabel === "Expédié" || statutLabel === "Reçu") && stockRestant > 0;
      
      if (isIncluded) {
        const produitId = achat.Produit;
        // On garde toujours le dernier achat pour chaque produit
        if (!achatsStockAmazonMap.has(produitId) || 
            new Date(achat.created_at) > new Date(achatsStockAmazonMap.get(produitId).created_at)) {
          achatsStockAmazonMap.set(produitId, {
            ...achat,
            stockRestant: stockRestant,
            montant: Number(achat.prixAchat) * stockRestant
          });
        }
      }
    });

    const achatsStockAmazon = Array.from(achatsStockAmazonMap.values());

    // Calcul des montants totaux
    const coutTotalAchatsEnCours = achatsEnCours.reduce((total, achat) => {
      const prixAchat = Number(achat.prixAchat) || 0;
      const quantite = Number(achat.Quantité) || 0;
      return total + (prixAchat * quantite);
    }, 0);

    const stockAmazon = achatsStockAmazon.reduce((total, achat) => total + achat.montant, 0);

    return { coutTotalAchatsEnCours, stockAmazon, achatsEnCours, achatsStockAmazon };
  }, [achats, statuts]);
} 